import { ArpMediaType } from '@arpeggi/shared'
import { useEffect, useState } from 'react'
import { IArpMedia } from '../../features/arp-registry/ArpMedia'
import ArpRegistry from '../../features/arp-registry/ArpRegistry'
import { useArpFavoritesAPI } from '../api/v2/ArpFavoritesAPI'
import { userIsLoggedIn } from '../components/core/Authentication'
import { useAsyncEffect } from '../components/platform/explore/common/utils'
import { useAuth } from './useAuth'

const useUserFavoritedMedia = () => {
  const { user } = useAuth()
  const [songsLoaded, setSongsLoaded] = useState<boolean>(false)
  const [stemsLoaded, setStemsLoaded] = useState<boolean>(false)
  const [samplesLoaded, setSamplesLoaded] = useState<boolean>(false)
  const [songData, setSongData] = useState<IArpMedia[] | null>(null)
  const { getUserFavorites } = useArpFavoritesAPI()

  useAsyncEffect(async () => {
    if (!userIsLoggedIn(user)) return

    setSongsLoaded(false)
    setStemsLoaded(false)

    if (user.favorite_songs) {
      const [_, favoriteSongs] = await Promise.all([
        getUserFavorites(user.wallet_address, {
          type: ArpMediaType.SONG,
          perPage: 1000,
          order: 'desc',
          parts: ['subComponents']
        }),
        ArpRegistry.getByIdsAsync(user.favorite_songs)
      ])
      setSongData(favoriteSongs)
      setSongsLoaded(true)
    } else {
      setStemsLoaded(true)
    }

    user.favorite_stems
      ? ArpRegistry.getByIdsAsync(user.favorite_stems).then(() => {
          setStemsLoaded(true)
        })
      : setStemsLoaded(true)
  }, [user])

  useEffect(() => {
    if (!userIsLoggedIn(user) || !ArpRegistry.readyForStudioUse) return

    user.favorite_samples
      ? ArpRegistry.getByIdsAsync(user.favorite_samples).then(() => {
          setSamplesLoaded(true)
        })
      : setSamplesLoaded(true)
  }, [user, ArpRegistry.readyForStudioUse])

  return { songsLoaded, stemsLoaded, samplesLoaded, songData }
}

export default useUserFavoritedMedia
